@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.content {
  background-color: @seller-settings--page--background-color;
}

.modal-body {
  height: 100%;
  overflow-y: hidden;
}

.settings-page-section-content {
  background-color: @seller-setting--page--section-container--background-color;
  padding: @space-16;
  border: solid 1px var(--default--border-color--10);
  border-radius: 8px;
  max-width: 700px;
  margin-top: @space-24;
}

.settings-page-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: @normal;
  max-width: 700px;
}

.settings-page-section-for-file-upload {
  max-width: 700px;
  font-size: 14px;
  font-weight: @normal;
}

.settings-page-section-header {
  padding-bottom: @space-24;
}

.sub-text-container {
  padding-bottom: @space-16;
}

.submit-button {
  margin-top: @space-8;
}

.auto-routing-link {
  font-size: 12px;
}

.auto-routing-info-box {
  max-width: 700px;
  padding: 10px;
  align-items: flex-start;
}

.save-order-routing-config {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: auto;
}

.enable-smart-routing-modal {
  max-width: 700px;
  height: 100%;
  overflow: hidden;
}

.disable-smart-routing-modal {
  max-width: 500px;
  height: 300px;

  .modal-body {
    padding: 10px 20px;
  }
}

.product-locations {
  padding: @space-16;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  .product-locations-checkbox {
    flex: 50%;
    margin-bottom: @space-12;
  }
}

.section-header {
  border-bottom: 1px solid var(--default--border-color--10);
}

.section-container {
  padding-top: @space-12;
}

.bolded {
  font-weight: 700;
}

.auto-routing-bulleted-list {
  list-style-position: outside;
  padding-left: @space-24;
}

.auto-routing-bulleted-list-item {
  list-style: disc;
  display: list-item;
}

.auto-routing-numbered-list-item {
  display: list-item;
}

.auto-routing-setup-link {
  font-size: 16px;
}

.fulfillment-priorities {
  color: @auto-split-option--label--font-color;
}

.fulfillment-priorities-option {
  padding: @space-8 @space-0;
}

.fulfillment-priorities-radio-button {
  padding: @space-0;
}
